<template>
    <div class="row">
        <div class="col-12">
            <div class="content-gallery">
            <p class="content-gallery--credit">{{caption}}</p>
            <div class="gallery-content--images-content">
                <div class="content-gallery--images">
                    <div class="content-gallery--item" v-for="item in value" :key="item.image.id">
                        <img :src="utils.image(item.image, 1120, 520)" alt="" />
                    </div>          
                </div>

                <div class="paginator-center">
                    <ul>
                        <li class="prev"></li>
                        <li class="next"></li>
                    </ul>
                </div>
            </div>

            <div class="content-gallery--thumbs">
                <div class="content-gallery--item" v-for="item in value" :key="item.image.id">
                    <img :src="utils.image(item.image, 160, 102)" alt="" />
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import 'slick-carousel'

import utils from '@/utils'

export default {
    name: 'Carousel',
    props: ['value'],
    data: function() {
        return {
            utils:utils,
            caption: null
        }
    },
    mounted(){
        let self = this
        this.caption = this.value[0].caption
        $(document).ready(function() {
            $(`.content-gallery--images`).not('.slick-initialized').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                asNavFor: ".content-gallery--thumbs",
                prevArrow: $('.prev'),
                nextArrow: $('.next'),
            })

            $(`.content-gallery--thumbs`).not('.slick-initialized').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: ".content-gallery--images",
                dots: true,
                centerMode: true,
                arrows: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            centerPadding: '20px',
                            centerMode: false,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
            $(".content-gallery--images").on('afterChange', function(slick, currentSlide){
                let index = currentSlide.currentSlide
                self.caption = self.value[index].caption
            })
        })
    }
}
</script>